import React, { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import Grid from '@mui/material/Grid2'
import Typography from '@mui/material/Typography'
import sx from './styles'

const SellFastItem = (props) => {
  const {
    title, description, icon,
  } = props

  return (
    <Grid
      container
      sx={sx.root}
    >
      <Grid
        size={{
          xs: 1,
          sm: 12,
        }}
        sx={sx.icon}
      >
        {icon}
      </Grid>
      <Grid
        size={{
          xs: 10,
          sm: 12,
        }}
      >
        {title && (
          <Grid size="grow">
            <Typography
              variant="subtitle2"
              component="p"
              sx={sx.title}
            >
              <FormattedMessage id={title} />
            </Typography>
          </Grid>
        )}
      </Grid>
      <Grid size="grow">
        {description && (
          <Grid
            size={12}
          >
            <Typography
              variant="body2"
              sx={sx.description}
            >
              <FormattedMessage id={description} />
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  )
}

export default memo(SellFastItem)
